import React from 'react';

/**
 * AmbientBackground — drifting aurora orbs + subtle grain + cursor spotlight.
 * Render once at the AppShell level; everything else stacks on top.
 */
export function AmbientBackground() {
  React.useEffect(() => {
    const spot = document.getElementById('spotlight-2050');
    if (!spot) return;
    const onMove = (e) => {
      spot.style.setProperty('--mx', e.clientX + 'px');
      spot.style.setProperty('--my', e.clientY + 'px');
    };
    document.addEventListener('mousemove', onMove);
    return () => document.removeEventListener('mousemove', onMove);
  }, []);
  return (
    <>
      <div className="aurora" aria-hidden="true">
        <span className="orb o1" />
        <span className="orb o2" />
        <span className="orb o3" />
      </div>
      <div className="grain" aria-hidden="true" />
      <div className="spotlight" id="spotlight-2050" aria-hidden="true" />
    </>
  );
}
export default AmbientBackground;
